import { cellComponents } from "@portal/BaseComponents/Table/Components/cellComponents";
import { TableWrapper } from "@portal/BaseComponents/Table/Components/style";
import { defaultColumnDefs } from "@portal/BaseComponents/Table/default";
import { useDocumentListQuery } from "@portal/queries/document-query";
import { documentFiltersAtom } from "@portal/store/Filters/documents/document-filter";
import { tableAtom } from "@portal/store/table/table";
import { DocumentList } from "@portal/types/entities/documents";
import { Sorter, Table } from "@sinecycle/growcomponents";
import produce from "immer";
import { useAtom } from "jotai";
import { useColumns } from "./Columns/useColumns";

function DocumentLists() {
  const [tableValue, setTable] = useAtom(tableAtom);
  const [documentFilters, setDocumentFilters] = useAtom(documentFiltersAtom);
  const { data, isLoading } = useDocumentListQuery({
    page: tableValue.currentPage,
    size: 10,
    filters: {
      ...documentFilters.sorting,
      ...documentFilters.filterValues,
    },
  });

  const { defaultColConfigs } = useColumns();
  function handleSort(sortParams: Sorter) {
    setDocumentFilters((filter) => {
      return produce(filter, (draft) => {
        draft.sorting = {
          order: sortParams.sortOrder,
          sort_col: sortParams.sortCol,
        };
      });
    });
  }

  return (
    <TableWrapper>
      <Table<DocumentList>
        handlePageChange={(page) => {
          setTable((value) => {
            return produce(value, (draft) => {
              draft.currentPage = page;
              return draft;
            });
          });
        }}
        tableState={tableValue}
        sortMode={{
          type: "remote",
          onSortChange(values) {
            handleSort(values);
          },
        }}
        loading={isLoading}
        gridProps={{
          rowData: data?.list,
          columnDefs: defaultColConfigs,
          defaultColDef: {
            ...defaultColumnDefs,
            sortable: false,
            flex: 1,
          },
          suppressMovableColumns: true,
          components: cellComponents,
          unSortIcon: true,
          enableCellTextSelection: true,
        }}
        variants={{
          actionbuttonswithq: true,
        }}
        enableColumnCustom={{
          type: "header-only",
          content: {
            preserve: {
              type: "LOCAL",
              storageKey: "DOCUMENTS_PORTAL",
            },
          
          },
        }}
      />
    </TableWrapper>
  );
}

export { DocumentLists };
